/**
 * @generated SignedSource<<5f0352ea5e95461dc3dee1996f966d65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_ToolDataQuery$variables = {
  modelId: string;
  pricingFirst: number;
  productId: number;
};
export type productSidePanelContent_ToolDataQuery$data = {
  readonly additionalAttributesByProduct: {
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly aiProductStagingRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly aiProductStagingRulesCount: number;
  readonly aiVirtualModelRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly aiVirtualModelRulesCount: number;
  readonly areaBackgroundRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly areaBackgroundRulesCount: number;
  readonly designTemplates: ReadonlyArray<{
    readonly designTemplateId: number;
    readonly name: string;
    readonly previewUrl: string;
  }>;
  readonly designWithAISetting: {
    readonly settingsID: number;
  } | null;
  readonly extensionFields: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesCount: number;
  readonly hasShapes: boolean;
  readonly imageGeneration: {
    readonly id: string;
    readonly serviceIDEdit: number | null;
    readonly serviceIDGeneration: number | null;
  } | null;
  readonly imageMacroCategories: ReadonlyArray<{
    readonly hasImages: boolean;
  }>;
  readonly moqRulesCount: number;
  readonly myAdditionalAttributes: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly placementsOutput: ReadonlyArray<{
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly placementOutputID: number;
  }>;
  readonly presetConfigurationsByProduct: ReadonlyArray<{
    readonly compositionID: number;
    readonly id: string;
    readonly name: string | null;
    readonly previewImageUrl: string | null;
  }>;
  readonly pricings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly pricingsDetailed: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
  readonly productMultipleVariantsRule: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
  readonly profanityFilterRulesCount: number;
  readonly profanityFilterRulesForProduct: {
    readonly printTypeRules: ReadonlyArray<{
      readonly key: number;
      readonly value: {
        readonly ruleID: number;
        readonly ruleName: string;
      } | null;
    }>;
    readonly productRule: {
      readonly ruleID: number;
      readonly ruleName: string;
    } | null;
  } | null;
  readonly quoteRulesCount: number;
  readonly shapesAssignments: {
    readonly printTypesIDs: ReadonlyArray<string>;
    readonly productsIDs: ReadonlyArray<string>;
  };
  readonly shapesAssignmentsForProduct: {
    readonly forProduct: boolean | null;
    readonly printTypesIDs: ReadonlyArray<number>;
  };
  readonly shapesCount: number;
};
export type productSidePanelContent_ToolDataQuery = {
  response: productSidePanelContent_ToolDataQuery$data;
  variables: productSidePanelContent_ToolDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pricingFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "designTemplateId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "productID",
    "variableName": "modelId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "Composition",
  "kind": "LinkedField",
  "name": "presetConfigurationsByProduct",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositionID",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previewImageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "kind": "Variable",
  "name": "productID",
  "variableName": "productId"
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypesIDs",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "ShapesAssignmentsForProduct",
  "kind": "LinkedField",
  "name": "shapesAssignmentsForProduct",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forProduct",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "ShapesAssignments",
  "kind": "LinkedField",
  "name": "shapesAssignments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productsIDs",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasShapes",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shapesCount",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PricingGroup",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "pricingFirst"
    },
    (v10/*: any*/)
  ],
  "concreteType": "PricingsDetailedConnection",
  "kind": "LinkedField",
  "name": "pricingsDetailed",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingsDetailedEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleName",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "ProfanityFilterAssignmentsForProduct",
  "kind": "LinkedField",
  "name": "profanityFilterRulesForProduct",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfanityFilterRuleRef",
      "kind": "LinkedField",
      "name": "productRule",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfanityFilterPrintTypeRuleRef",
      "kind": "LinkedField",
      "name": "printTypeRules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterRuleRef",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  (v8/*: any*/),
  (v5/*: any*/)
],
v22 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "AIProductStagingRuleOutput",
  "kind": "LinkedField",
  "name": "aiProductStagingRulesByProduct",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "AIVirtualModelRuleOutput",
  "kind": "LinkedField",
  "name": "aiVirtualModelRulesByProduct",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "GridRule",
  "kind": "LinkedField",
  "name": "gridRulesByProduct",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "AreaBackgroundRuleTool",
  "kind": "LinkedField",
  "name": "areaBackgroundRulesByProduct",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "AdditionalAttribute",
  "kind": "LinkedField",
  "name": "additionalAttributesByProduct",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalAttributeID",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "status",
      "value": 0
    }
  ],
  "concreteType": "AdditionalAttribute",
  "kind": "LinkedField",
  "name": "myAdditionalAttributes",
  "plural": true,
  "selections": [
    (v8/*: any*/)
  ],
  "storageKey": "myAdditionalAttributes(status:0)"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profanityFilterRulesCount",
  "storageKey": null
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v30 = {
  "alias": null,
  "args": (v29/*: any*/),
  "concreteType": "PrintTypesConnection",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PrintTypesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PrintType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "printTypeID",
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "printTypes(first:200)"
},
v31 = {
  "alias": null,
  "args": (v29/*: any*/),
  "concreteType": "PricingsConnection",
  "kind": "LinkedField",
  "name": "pricings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "pricings(first:200)"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaBackgroundRulesCount",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gridRulesCount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "modelId"
    }
  ],
  "concreteType": "PlacementOutput",
  "kind": "LinkedField",
  "name": "placementsOutput",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placementOutputID",
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageGenerationDTO",
  "kind": "LinkedField",
  "name": "imageGeneration",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceIDGeneration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceIDEdit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settingsID",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productId",
      "variableName": "modelId"
    }
  ],
  "concreteType": "ProductMultipleVariantsRule",
  "kind": "LinkedField",
  "name": "productMultipleVariantsRule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeCodes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameAndNumberEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skipOptionForNameAndNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulkAsNameAndNumberEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableImportCSV",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "options",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiProductStagingRulesCount",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiVirtualModelRulesCount",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moqRulesCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRulesCount",
  "storageKey": null
},
v42 = [
  {
    "kind": "Literal",
    "name": "onlybackground",
    "value": false
  }
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "ExtensionField",
  "kind": "LinkedField",
  "name": "extensionFields",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DesignTemplate",
        "kind": "LinkedField",
        "name": "designTemplates",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignWithAISettingDTO",
        "kind": "LinkedField",
        "name": "designWithAISetting",
        "plural": false,
        "selections": [
          (v36/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      {
        "alias": null,
        "args": (v42/*: any*/),
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v43/*: any*/)
        ],
        "storageKey": "imageMacroCategories(onlybackground:false)"
      },
      (v44/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DesignTemplate",
        "kind": "LinkedField",
        "name": "designTemplates",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignWithAISettingDTO",
        "kind": "LinkedField",
        "name": "designWithAISetting",
        "plural": false,
        "selections": [
          (v36/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      {
        "alias": null,
        "args": (v42/*: any*/),
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v43/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": "imageMacroCategories(onlybackground:false)"
      },
      (v44/*: any*/)
    ]
  },
  "params": {
    "cacheID": "3123d1bc508f89115b4f42850d2ebc2c",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ToolDataQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ToolDataQuery(\n  $productId: Long!\n  $modelId: ID!\n  $pricingFirst: Int!\n) {\n  designTemplates(productId: $productId) {\n    designTemplateId\n    name\n    previewUrl\n    id\n  }\n  presetConfigurationsByProduct(productID: $modelId) {\n    id\n    compositionID\n    name\n    previewImageUrl\n  }\n  shapesAssignmentsForProduct(productID: $productId) {\n    forProduct\n    printTypesIDs\n  }\n  shapesAssignments {\n    productsIDs\n    printTypesIDs\n  }\n  hasShapes\n  shapesCount\n  pricingsDetailed(productID: $productId, first: $pricingFirst) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  profanityFilterRulesForProduct(productID: $productId) {\n    productRule {\n      ruleID\n      ruleName\n    }\n    printTypeRules {\n      key\n      value {\n        ruleID\n        ruleName\n      }\n    }\n  }\n  aiProductStagingRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  aiVirtualModelRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  gridRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  areaBackgroundRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  additionalAttributesByProduct(productID: $modelId) {\n    id\n    additionalAttributeID\n    name\n  }\n  myAdditionalAttributes(status: 0) {\n    id\n  }\n  profanityFilterRulesCount\n  printTypes(first: 200) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n  pricings(first: 200) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  areaBackgroundRulesCount\n  gridRulesCount\n  placementsOutput(id: $modelId) {\n    id\n    placementOutputID\n    name\n    isEnabled\n  }\n  imageGeneration {\n    id\n    serviceIDGeneration\n    serviceIDEdit\n  }\n  designWithAISetting {\n    settingsID\n    id\n  }\n  productMultipleVariantsRule(productId: $modelId) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n  aiProductStagingRulesCount\n  aiVirtualModelRulesCount\n  moqRulesCount\n  quoteRulesCount\n  imageMacroCategories(onlybackground: false) {\n    hasImages\n    id\n  }\n  extensionFields {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "29647b0ac8a6772bc192f0dd48c9b19b";

export default node;
